export default __webpack_public_path__ + "static/media/appointment-onboarding-carousel-web.8ee27e7d.png";